"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/gate/EventDispatcher");
var mobx_1 = require("mobx");
var helper_1 = require("lib/functions/helper");
var Model = (function () {
    function Model(gate, dataStore) {
        this.gate = gate;
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
        this.isLoading = false;
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false)) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.getApiKeyBySlug = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        this.dispatcher.dispatch();
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/api/key/credentials", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data.api_key_user_id = r.data.userId;
                                this.json_data.api_key_profile_id = r.data.profileId;
                                this.json_data.profile = r.data.profile;
                                this.json_data.type = r.data.type;
                            }
                        }
                        this.isLoading = false;
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_1 = _a.sent();
                        this.isLoading = false;
                        this.dispatcher.dispatch();
                        console.log("some error with getApiKeyBySlug", error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getTaskUserInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        this.dispatcher.dispatch();
                        options = __assign({}, this.urlQueryParams);
                        return [4, this.gate.request("/v3/tasks/by-user", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data = r.data.json_data;
                                this.json_data.type = r.data.type;
                                this.json_data.user_id = r.data.user_id;
                                this.json_data.x_profile_id = r.data.x_profile_id;
                                this.json_data.task_id = r.data.task_id;
                                this.json_data.task_user_id = r.data.task_user_id;
                                this.json_data.sl = r.data.sl;
                            }
                        }
                        this.isLoading = false;
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_2 = _a.sent();
                        this.isLoading = false;
                        this.dispatcher.dispatch();
                        console.log("some error with getTaskUserInformation", error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getPrograms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, options, r, newPrograms, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/programs/" + campusId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newPrograms = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, description = _a.description;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + description
                                });
                            });
                            this.json_data.programs = newPrograms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_3 = _a.sent();
                        console.log("some error with getPrograms", error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getCampuses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, newCampuses, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/campuses", {
                                data: options,
                                isFixedCampuses: true
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            if (Object.keys(r.data).length > 0) {
                                newCampuses = r.data.map(function (_a) {
                                    var id = _a.id, name = _a.name, abbreviation = _a.abbreviation, checked = _a.checked;
                                    return ({
                                        name: name,
                                        value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + abbreviation + helper_1.DELIMITER + checked
                                    });
                                });
                                this.json_data.campuses = newCampuses;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_4 = _a.sent();
                        console.log("some error with getCampuses", error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getProgramVersions = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var programId, options, r, newProgramVersions, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        programId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/major-versions/" + programId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newProgramVersions = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, effectiveDate = _a.effectiveDate;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + effectiveDate
                                });
                            });
                            this.json_data.program_versions = newProgramVersions;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_5 = _a.sent();
                        console.log("some error with getProgramVersions", error_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getAcademicShifts = function (campusValue, programValue) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, programId, options, r, newAcademicShifts, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = helper_1.getPartsByDelimiter(campusValue)[0];
                        programId = helper_1.getPartsByDelimiter(programValue)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/academic-shifts/" + campusId + "/" + programId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newAcademicShifts = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, isActive = _a.isActive, programVersionId = _a.programVersionId;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + isActive + helper_1.DELIMITER + programVersionId
                                });
                            });
                            this.json_data.academic_shifts = newAcademicShifts;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_6 = _a.sent();
                        console.log("some error with getAcademicShifts", error_6);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "user", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "urlQueryParams", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "isLoading", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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